import { useState, useEffect } from 'react';
import { useCart } from '../../hooks/useCart';
import { getProductImage } from '../../utils/imageStorage';

export default function ProduitAngeAPoser25cm() {
  const { addToCart } = useCart();
  const [quantity, setQuantity] = useState(1);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const productId = 'ange-a-poser-25cm';
  const defaultImage = 'https://public.readdy.ai/ai/img_res/7c861076-4330-401d-9c9f-9d520b2e9bf0.png';
  const [productImage, setProductImage] = useState<string>(defaultImage);

  const product = {
    id: 'ange-a-poser-25cm',
    name: 'Ange à poser – 25 cm',
    price: 30,
    image: productImage,
    description: 'Poétique et lumineux, cet ange à poser est entièrement réalisé à la main à partir d\'un livre recyclé. Chaque pli, chaque détail – des ailes jusqu\'à la petite étoile dorée – est façonné avec soin et amour 💫',
    details: {
      fabrication: 'Fait main dans l\'atelier Les Carnets de Lolotte',
      type: 'Pièce artisanale unique',
      dimensions: '25 cm de hauteur',
      delai: '2 à 3 jours',
      materials: 'Papier recyclé, ruban et étoile dorée'
    }
  };

  const handleAddToCart = () => {
    addToCart({
      id: product.id,
      name: product.name,
      price: product.price,
      image: productImage,
      description: product.description
    }, quantity);
    
    // Feedback visuel
    const button = document.activeElement as HTMLButtonElement;
    if (button) {
      const originalText = button.innerHTML;
      button.innerHTML = '<i class="ri-check-line mr-2"></i>Ajouté au panier !';
      button.disabled = true;
      setTimeout(() => {
        button.innerHTML = originalText;
        button.disabled = false;
      }, 2000);
    }
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  useEffect(() => {
    const loadImage = async () => {
      const savedImage = await getProductImage(productId);
      if (savedImage) {
        setProductImage(savedImage);
      }
    };
    loadImage();
  }, []);

  return (
    <div className="min-h-screen bg-[#F8EDEA]">
      {/* Breadcrumb */}
      <section className="py-4 bg-[#FAF9F8]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="flex items-center space-x-2 text-sm" style={{ fontFamily: 'Poppins, sans-serif' }}>
            <a href="/" className="text-[#6B5E5A] hover:text-[#B97A72] transition-colors">Accueil</a>
            <i className="ri-arrow-right-s-line text-[#B97A72]"></i>
            <a href="/boutique" className="text-[#6B5E5A] hover:text-[#B97A72] transition-colors">Boutique</a>
            <i className="ri-arrow-right-s-line text-[#B97A72]"></i>
            <a href="/noel" className="text-[#6B5E5A] hover:text-[#B97A72] transition-colors">Collection de Noël</a>
            <i className="ri-arrow-right-s-line text-[#B97A72]"></i>
            <span className="text-[#B97A72] font-medium">{product.name}</span>
          </nav>
        </div>
      </section>

      {/* Product Section */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12">
            {/* Image du produit */}
            <div>
              <div className="w-full h-[500px] bg-white rounded-lg overflow-hidden shadow-lg mb-4">
                <img
                  src={productImage}
                  alt="Ange à poser – 25 cm"
                  className="w-full h-full object-contain"
                />
              </div>
            </div>

            {/* Product Info */}
            <div className="space-y-8">
              <div>
                <h1 className="text-5xl font-bold text-[#B97A72] mb-6" style={{ fontFamily: 'Allura, cursive' }}>
                  ✨ {product.name}
                </h1>
                
                <p className="text-xl text-[#6B5E5A] leading-relaxed mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  {product.description}
                </p>

                <div className="bg-[#FAF9F8] border-2 border-[#F8EDEA] rounded-xl p-6 mb-6">
                  <p className="text-lg text-[#6B5E5A] leading-relaxed mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
                    Idéal pour décorer une table, un buffet ou un coin de fête, il apportera une touche chaleureuse et féérique à votre intérieur.
                  </p>
                  <p className="text-lg text-[#B97A72] font-medium italic" style={{ fontFamily: 'Playfair Display, serif' }}>
                    🕊️ Chaque ange porte un souffle de paix et d'émerveillement, à offrir ou à s'offrir…
                  </p>
                </div>
              </div>

              {/* Specifications */}
              <div className="bg-white border-2 border-[#F8EDEA] rounded-xl p-6 space-y-4">
                <h3 className="text-2xl font-semibold text-[#B97A72] mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
                  Caractéristiques
                </h3>
                <div className="space-y-3">
                  <div className="flex items-center">
                    <span className="font-medium text-[#B97A72] w-32" style={{ fontFamily: 'Playfair Display, serif' }}>💕 Hauteur :</span>
                    <span className="text-[#6B5E5A]" style={{ fontFamily: 'Poppins, sans-serif' }}>{product.details.dimensions}</span>
                  </div>
                  <div className="flex items-start">
                    <span className="font-medium text-[#B97A72] w-32" style={{ fontFamily: 'Playfair Display, serif' }}>📖 Matériaux :</span>
                    <span className="text-[#6B5E5A]" style={{ fontFamily: 'Poppins, sans-serif' }}>{product.details.materials}</span>
                  </div>
                  <div className="flex items-center">
                    <span className="font-medium text-[#B97A72] w-32" style={{ fontFamily: 'Playfair Display, serif' }}>🕯️ Fabrication :</span>
                    <span className="text-[#6B5E5A]" style={{ fontFamily: 'Poppins, sans-serif' }}>Fait main – pièce unique</span>
                  </div>
                </div>
              </div>

              {/* Price and Add to Cart */}
              <div className="bg-[#EBD2CF] border-2 border-[#B97A72] rounded-xl p-8">
                <div className="flex items-center justify-between mb-6">
                  <div>
                    <span className="text-5xl font-bold text-[#B97A72]" style={{ fontFamily: 'Playfair Display, serif' }}>
                      {product.price}€
                    </span>
                    <p className="text-sm text-[#6B5E5A] mt-1" style={{ fontFamily: 'Poppins, sans-serif' }}>
                      Livraison soignée incluse
                    </p>
                  </div>
                  <div className="text-right">
                    <div className="w-16 h-16 flex items-center justify-center mx-auto mb-2">
                      <i className="ri-star-line text-4xl text-[#B97A72]"></i>
                    </div>
                    <p className="text-xs text-[#6B5E5A]" style={{ fontFamily: 'Poppins, sans-serif' }}>
                      Création unique
                    </p>
                  </div>
                </div>

                <div className="space-y-4">
                  <div className="flex items-center space-x-4">
                    <label className="text-[#6B5E5A] font-medium" style={{ fontFamily: 'Playfair Display, serif' }}>
                      Quantité :
                    </label>
                    <div className="flex items-center border-2 border-[#B97A72] rounded-full overflow-hidden">
                      <button 
                        onClick={() => setQuantity(Math.max(1, quantity - 1))}
                        className="px-4 py-2 bg-[#F8EDEA] text-[#B97A72] hover:bg-[#E8CBA8] transition-colors"
                        style={{ fontFamily: 'Playfair Display, serif' }}
                      >
                        -
                      </button>
                      <span className="px-6 py-2 bg-white text-[#6B5E5A] font-medium" style={{ fontFamily: 'Poppins, sans-serif' }}>
                        {quantity}
                      </span>
                      <button 
                        onClick={() => setQuantity(quantity + 1)}
                        className="px-4 py-2 bg-[#F8EDEA] text-[#B97A72] hover:bg-[#E8CBA8] transition-colors"
                        style={{ fontFamily: 'Playfair Display, serif' }}
                      >
                        +
                      </button>
                    </div>
                  </div>

                  <button
                    onClick={handleAddToCart}
                    className="w-full bg-[#B97A72] text-white py-4 rounded-full text-lg font-semibold hover:bg-[#C49B86] transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center"
                    style={{ fontFamily: 'Playfair Display, serif' }}
                  >
                    <div className="w-6 h-6 flex items-center justify-center mr-3">
                      <i className="ri-shopping-cart-line text-xl"></i>
                    </div>
                    Ajouter au panier
                  </button>

                  <div className="flex items-center justify-center space-x-6 text-sm text-[#6B5E5A]" style={{ fontFamily: 'Poppins, sans-serif' }}>
                    <div className="flex items-center">
                      <i className="ri-truck-line mr-2 text-[#B97A72]"></i>
                      Livraison soignée
                    </div>
                    <div className="flex items-center">
                      <i className="ri-shield-check-line mr-2 text-[#B97A72]"></i>
                      Paiement sécurisé
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Description détaillée */}
      <section className="py-16 bg-[#FAF9F8]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-[#B97A72] mb-6" style={{ fontFamily: 'Allura, cursive' }}>
              L'art du pliage poétique
            </h2>
            <div className="bg-white border-2 border-[#F8EDEA] rounded-xl p-8 shadow-lg">
              <p className="text-lg text-[#6B5E5A] leading-relaxed mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Cet ange à poser de 25 cm est bien plus qu'une simple décoration : c'est une œuvre d'art unique, 
                née de la transformation poétique d'un livre ancien. Chaque page devient aile, chaque pli raconte une histoire.
              </p>
              <p className="text-lg text-[#6B5E5A] leading-relaxed mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Orné d'une petite étoile dorée et de détails délicats, il apporte une présence douce et lumineuse 
                à votre intérieur. Parfait pour une table de fête, un buffet ou un coin lecture.
              </p>
              <p className="text-xl text-[#B97A72] font-medium italic" style={{ fontFamily: 'Playfair Display, serif' }}>
                ✨ Une création artisanale qui transforme votre espace en un lieu de paix et d'émerveillement ✨
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Image Modal */}
      {selectedImage && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4"
          onClick={closeModal}
        >
          <div className="relative max-w-4xl max-h-full">
            <button
              onClick={closeModal}
              className="absolute -top-12 right-0 text-white text-2xl hover:text-gray-300 transition-colors"
            >
              <i className="ri-close-line"></i>
            </button>
            <img
              src={selectedImage}
              alt="Image agrandie"
              className="max-w-full max-h-full object-contain rounded-lg"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        </div>
      )}
    </div>
  );
}
